module.exports = __webpack_public_path__ + "static/media/msg-sad.071b766a.svg";